var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLivespotting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-4.854 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0085E9",
    d: "M0 2.293L4.078 12 .001 21.707 9.706 12z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0085E9",
    d: "M2.294 0L0 2.293 9.706 12 .001 21.707 2.294 24l11.999-12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivespotting);
export default __webpack_public_path__ + "static/media/livespotting.a4a3b5b36e3f335220c11aa9b9b107c7.svg";
export { ForwardRef as ReactComponent };